import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { useForm } from "react-hook-form";

import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import { CancelButton, SaveButton } from "../../../common/Button";
import { Container, Row, Col, Form } from "react-bootstrap";

const EditOffCanvance = (props) => {
  const { postData, getData, IMG_URL } = useContext(Context);

  const id = props.show; // your current logic

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [oldImage, setOldImage] = useState(null);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  // ✅ watch new image
  const imageFile = watch("image");

  // ✅ Get Edit Data
  const GetEditData = async () => {
    const response = await getData(`/information/our-locations/${id}`);

    const data = response?.data;

    reset({ name: data?.name, description: data?.description });

    setOldImage(data?.image); // existing image
  };

  useEffect(() => {
    if (id) GetEditData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // ✅ Submit
  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      formData.append("name", data.name);
      formData.append("description", data.description);
      // ✅ Only send image if user selected new one
      // if (data.image && data.image[0]) {
      //   formData.append("image", data.image[0]);
      // }

      const response = await postData(
        `/information/our-locations/${id}`,
        formData,
        true,
      );

      setShowModal({
        code: response.code,
        message: response.message,
      });

      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement="end"
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton />
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Edit Our Locations</Card.Title>
              <hr />

              <Container>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col lg={8} md={10} className="mx-auto Add-content">
                      {/* Name */}
                      <Row className="mt-4">
                        <Form.Label column sm={3}>
                          Name
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="text"
                            placeholder="Name"
                            {...register("name", {
                              required: "Name is required",
                            })}
                          />
                          {errors.name && (
                            <span className="text-danger">
                              {errors.name.message}
                            </span>
                          )}
                        </Col>
                      </Row>

                      {/* Address */}
                      <Row className="mt-4">
                        <Form.Label column sm={3}>
                          Address
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            as="textarea"
                            rows={5}
                            placeholder="Address"
                            {...register("description", {
                              required: "Address is required",
                            })}
                          />
                          {errors.description && (
                            <span className="text-danger">
                              {errors.description.message}
                            </span>
                          )}
                        </Col>
                      </Row>

                      {/* Image */}
                      {/* <Row className="mt-4">
                        <Form.Label column sm={3}>
                          Image
                        </Form.Label>
                        <Col sm={6}>
                          <Form.Control
                            type="file"
                            accept="image/*"
                            {...register("image")}
                          />

                          {imageFile && imageFile.length > 0 ? (
                            <div className="image-preview-container">
                              <img
                                src={URL.createObjectURL(imageFile[0])}
                                alt="Preview"
                                className="image-preview"
                                style={{
                                  width: "100%",
                                  height: "150px",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                }}
                              />
                            </div>
                          ) : (
                            oldImage && (
                              <div className="image-preview-container">
                                <img
                                  src={IMG_URL + oldImage}
                                  alt="Preview"
                                  className="image-preview"
                                  style={{
                                    width: "100%",
                                    height: "150px",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            )
                          )}
                        </Col>
                      </Row> */}

                      {/* Buttons */}
                      <Row className="mt-5 pb-3">
                        <div className="d-flex justify-content-center">
                          <Link>
                            <CancelButton
                              name="cancel"
                              handleClose={props.handleClose}
                            />
                          </Link>

                          <SaveButton name="save" type="submit" />
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={!!showModal.code}
      />
    </>
  );
};

export default EditOffCanvance;
